import { createContext } from 'react'
import { TSendersListing } from './types'

export const SendersListingContext = createContext<TSendersListing>({
    setSingleSender: undefined // Optional function to set single sender (from parent app)
})